export default __webpack_public_path__ + "static/media/429.67057d22.png";